import cookies from 'js-cookie';

import { removeCookie, safeJSONParse } from '../helpers/helpers';
import type { ICookieInit, TSetState } from '../models';

export abstract class BaseCookie {
    protected currentProducts: string[];

    protected cookieName: string;

    protected setState: TSetState;

    protected parsedCookie: Record<string, string> | null;

    constructor({ cookieName = '', products = [], setState }: ICookieInit) {
        this.cookieName = cookieName;
        this.setState = setState;
        this.parsedCookie = safeJSONParse(cookies.get(cookieName));
        this.currentProducts = typeof products === 'string' ? [products] : products;
    }

    abstract parseCookie(): void;

    removeCookie() {
        removeCookie(this.cookieName);
    }
}
